/**
 * Shared max-width breakpoints (px) for flight-changes list + detail layouts.
 * Use in styled-components as `@media (max-width: ${BREAKPOINT_MAX.xl}px)`.
 */
export const BREAKPOINT_MAX = {
  /** Below 1400px */
  xl: 1399,
  /** Below 1200px */
  lg: 1199,
  /** Below 1000px */
  md: 999,
} as const;
